import { useEffect, useState } from "react";
import { checkStaffAccess } from "../apis/checkStaffAccess";
import AdminHeader from "../components/desktop/DE/AdminSetting/AdminHeader/AdminHeader";
import { getInsightDetails } from "../apis/getInsightDetails";

type Props = {};

function AdminSetting(Props: Props) {
  const [staff, setStaff] = useState<boolean | null>(null);
  const [insightDetails, setInsightDetails] = useState();

  useEffect(() => {
    checkStaffAccess()
      .then((isStaff) => {
        setStaff(isStaff);
      })
      .catch(() => {
        setStaff(false);
      });

    getInsightDetails()
      .then((insightResponse) => {
        setInsightDetails(insightResponse?.document_insights);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return <AdminHeader staff={staff} insightDetails={insightDetails} />;
}

export default AdminSetting;
